// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner_wrapper__1L8nk","container":"Spinner_container__1BkTk","element":"Spinner_element__3fYFx","element-animation":"Spinner_element-animation__2GtuR"};